module.exports = __webpack_public_path__ + "1875d2e4925b1e4448b453e6cfa4ce42.svg";